export default __webpack_public_path__ + "static/media/azure-registry.ed3882a9.svg";